export default __webpack_public_path__ + "static/media/seek-button.755a66a7.svg";